import { User } from '@overtur-monorepo/keying-user'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { NavService } from '../../../services/nav.service'
import { Subject, BehaviorSubject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { fadeIn } from '../../../animations/fadeIn'
import { AppRoutingConfig } from '../../../configuration/app.routing.config'
import { keySystemDisplayColumns } from '../../../constants/keying.constants'
import { NewKeySystemDialogComponent } from '../../../dialogs/new-key-system-dialog/new-key-system-dialog.component'
import { KeySystem, Library, Structure } from '../../../models/dev.test.models'
import { KeyingAuthService } from '../../../services/keying.auth.service'
import { KeyingDataSetsService } from '../../../services/keying.data.sets.service'
import { KeyingStructureService } from '../../../services/keying.structure.service'
import { KeyingSystemService } from '../../../services/keying.system.service'
import { Loading, LoadingService } from '../../../services/loading.service'

@Component({
    selector: 'app-independent-key-systems',
    templateUrl: './independent-key-systems.component.html',
    styleUrls: ['./independent-key-systems.component.scss'],
    animations: [fadeIn],
    standalone: false
})
export class IndependentKeySystemsComponent implements OnInit, OnDestroy {
  destroy$ = new Subject()
  loading: Loading

  keyingDisplayColumns = keySystemDisplayColumns
  filteredKeySystems = new BehaviorSubject<Array<any>>([])
  library = new Library()
  structures: Array<Structure> = []
  structure
  users: User[]
  user: User

  constructor(
    private router: Router,
    private keyingStructureService: KeyingStructureService,
    private keyingSystemService: KeyingSystemService,
    private navService: NavService,
    private dialog: MatDialog,
    private loadingService: LoadingService,
    public keyingDataSetsService: KeyingDataSetsService,
    private keyingAuthService: KeyingAuthService
  ) {}

  /* istanbul ignore next */
  ngOnInit(): void {
    this.loadingService.loading$.pipe(takeUntil(this.destroy$)).subscribe((loading) => {
      this.loading = loading
    })

    this.keyingStructureService.structure$.pipe(takeUntil(this.destroy$)).subscribe((structure) => {
      if (!structure) {
        return
      }
      this.structure = structure

      let navButtons = [
        {
          name: 'Dashboard',
          active: true,
          icon: 'layout',
          router: AppRoutingConfig.getGenericStructureUrl('structureNewKeySystems', this.structure.id),
        },
      ]
      this.navService.setEntities(navButtons)
      this.filteredKeySystems.next(this.structure.keySystems)
    })
  }

  /* istanbul ignore next */
  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  /* istanbul ignore next */
  selectKeySystem(keySystem: KeySystem) {
    this.keyingSystemService.selectKeySystem(keySystem)
    this.router.navigate([AppRoutingConfig.getStructureUrl(this.structure.id, keySystem.id)])
  }

  /* istanbul ignore next */
  openDialog(): void {
    const dialogRef = this.dialog.open(NewKeySystemDialogComponent, {
      data: this.structure,
    })

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.createKeySystem(data)
      }
    })
  }

  /* istanbul ignore next */
  navNewStructure() {
    this.router.navigate([AppRoutingConfig.newStructureUrl])
  }

  /* istanbul ignore next */
  createKeySystem(data) {
    data.structure = this.structure
    this.keyingStructureService.createKeySystem(data)
  }

  /* istanbul ignore next */
  updateSearch() {}

  /* istanbul ignore next */
  allowDeleteElement() {
    this.keyingAuthService.keyingUser$.pipe(takeUntil(this.destroy$)).subscribe((user) => {
      if (!user) {
        return
      }
      this.user = user
    })
    if (this.user.id === this.filteredKeySystems.value[0].lockedById) {
      return true
    } else {
      return false
    }
  }
}
